import FileSaver from "file-saver";

export function convertDotToCommaInNumber(number) {
	if (!number) return '0';
	return (number + "").replace(".", ",");
}

export function listOfStringToConcatenatedString(list, separator = ",") {
	if (!Array.isArray(list)) {
		return "";
	}
	return list.join(separator + " ");
}

export function extractFileNameAndSave(response, blob) {
	const fileName = response.headers['content-disposition'].split('filename=')[1].split(';')[0];
	FileSaver.saveAs(blob, fileName.substring(1, fileName.length - 1));
}

export function numberToHumanReadableHours(num) {
	let cleanNum = num.toFixed(1);
	let hours = ~~cleanNum;
	let minutes = ((hours - cleanNum).toFixed(1)) * 60;

	return minutes === 0 ? `${hours} uur` : `${hours} uur en ${minutes} minuten`;
}